export default {"src":"/_next/static/media/sightsea-light.6aaecc7c.svg","height":40,"width":179,"blurWidth":0,"blurHeight":0};